module.exports = "https://health.dajiuxing.com.cn/img/assets/rightsDetails/self-operated/self-operatedbg-4980.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FrightsDetails%2Fself-operated%2Fself-operatedbg-4980.jpg
// module id = mkbV
// module chunks = 93